import type {JSX} from 'react'

export const FallbackBlock = (): JSX.Element => {
	return (
		<div className="container-narrow">
			<div className="h-96 bg-blue-900" />
		</div>
	)
}
